// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","container":"Feedback__container--a9","caption":"Feedback__caption--Rn","closeButton":"Feedback__closeButton--MQ"};